module.exports = __webpack_public_path__ + "assets/core-js.de2ca9d4.svg";